import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import ServicePageLayout from "../components/ServicePageLayout";
import { useGuestSession } from "contexts/GuestSessionContext";
import { LUXURY } from "data/guestLuxuryTheme";

const InfoBlock = ({ title, children, action }) => (
  <Box
    sx={{
      p: 1.85,
      borderRadius: "18px",
      bgcolor: LUXURY.card,
      border: `1px solid ${LUXURY.cardBorder}`,
    }}
  >
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography sx={{ fontWeight: 700, mb: 0.45, lineHeight: 1.3, wordBreak: "break-word", color: LUXURY.ink }}>
          {title}
        </Typography>
        <Typography sx={{ color: LUXURY.muted, fontSize: "0.9rem", lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {children}
        </Typography>
      </Box>
      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Stack>
  </Box>
);

const StayPage = () => {
  const { portalConfig, company, isRoom } = useGuestSession();
  const stay = portalConfig.stay;

  const copyWifi = async () => {
    try {
      await navigator.clipboard.writeText(stay.wifiPassword || "");
      toast.success("Wi-Fi password copied");
    } catch {
      toast.info(stay.wifiPassword);
    }
  };

  return (
    <ServicePageLayout
      title={isRoom ? "Stay guide" : "Restaurant info"}
      subtitle="Wi-Fi, hours, facilities, and house notes — tap to copy what you need."
      illustration="stay"
    >
      <Stack spacing={1.25}>
        <InfoBlock
          title="Wi-Fi"
          action={
            <Button
              onClick={copyWifi}
              sx={{ fontWeight: 800, minHeight: 40, color: LUXURY.goldDeep }}
            >
              Copy
            </Button>
          }
        >
          {`Network: ${stay.wifiName}\nPassword: ${stay.wifiPassword}`}
        </InfoBlock>
        {stay.checkinTime ? (
          <InfoBlock title="Check-in">{`From ${stay.checkinTime}`}</InfoBlock>
        ) : null}
        {company?.phone || stay.frontDeskPhone ? (
          <InfoBlock title="Front desk">{stay.frontDeskPhone || company.phone}</InfoBlock>
        ) : null}
        <InfoBlock title="Parking">{stay.parking}</InfoBlock>
        <InfoBlock title="Directory">{stay.directory}</InfoBlock>
        <InfoBlock title="Policies">{stay.policies}</InfoBlock>
        {(portalConfig.facilities || []).map((item) => (
          <InfoBlock key={item.id} title={item.title}>
            {`${item.hours}\n${item.note}`}
          </InfoBlock>
        ))}
      </Stack>
    </ServicePageLayout>
  );
};

export default StayPage;
